<template>
    <div>
        <span @click="toggleModal">
            <slot name="activator" />
        </span>

        <div class="modal is-active" v-if="show">
            <div class="modal-background" @click="toggleModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ title }}</p>
                    <button class="delete" @click.prevent="toggleModal"></button>
                </header>
                <section class="modal-card-body">
                    <slot />
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <slot name="footer" v-bind:toggle-modal="toggleModal">
                        <button
                            v-if="submitButton"
                            class="button is-primary"
                            :class="{ 'is-loading': isLoading }"
                            :disabled="isButtonDisabled"
                            @click="submit"
                        >
                            {{ submitButton }}
                        </button>
                        <button class="button" @click="toggleModal">{{ abortButton || $t('generic.cancel') }}</button>
                    </slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'modal',
        props: {
            title: {
                type: String,
                default: '',
            },
            submitButton: {
                type: String,
                default: '',
            },
            abortButton: {
                type: String,
                default: '',
            },
            onSubmit: {
                type: Function,
                default: null,
            },
            isButtonDisabled: {
                type: Boolean,
                default: false,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                show: false,
                disableSubmit: false,
            };
        },

        methods: {
            toggleModal() {
                this.show = !this.show;

                if(!this.show) {
                    this.$emit('closed');
                }
            },
            async submit() {
                if(!this.disableSubmit) {
                    await this.onSubmit();
                    this.toggleModal();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/components/modal/modal.vue